/* eslint-disable @typescript-eslint/no-explicit-any */
import Review from '../../server/domain/Review';

export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const SWITCH_PAGE = 'SWITCH_PAGE';
export const LOAD_REVIEWS = 'LOAD_REVIEWS';
export const LOAD_REVIEWS_SUCCESS = 'LOAD_REVIEWS_SUCCESS';
export const LOAD_REVIEWS_ERROR = 'LOAD_REVIEWS_ERROR';

export interface LoadReviewsActionPayload {
  product_id: number;
  store_id: number;
  page: number;
  limit: number;
}

export interface FetchReviewsActionPayload extends LoadReviewsActionPayload {
  reviewsMap: Map<number, Review[]>;
}

export interface LoadReviewsSuccessActionPayload {
  currentPage: number;
  totalPages: number;
  reviews: Review[];
}

export interface SwitchPageAction {
  type: typeof SWITCH_PAGE;
  payload: LoadReviewsActionPayload;
}

interface LoadReviewsAction {
  type: typeof LOAD_REVIEWS;
  payload: LoadReviewsActionPayload;
}

interface LoadReviewsSuccessAction {
  type: typeof LOAD_REVIEWS_SUCCESS;
  payload: LoadReviewsSuccessActionPayload;
}

interface LoadReviewsErrorAction {
  type: typeof LOAD_REVIEWS_ERROR;
  payload: any;
}

export type LoadReviewsActions =
  | LoadReviewsAction
  | LoadReviewsSuccessAction
  | LoadReviewsErrorAction
  | SwitchPageAction;

export function loadReviews(payload: LoadReviewsActionPayload): LoadReviewsAction {
  return { type: LOAD_REVIEWS, payload };
}

export function loadReviewsSuccess(payload: LoadReviewsSuccessActionPayload): LoadReviewsSuccessAction {
  return { type: LOAD_REVIEWS_SUCCESS, payload };
}

export function loadReviewsError(payload: any): LoadReviewsErrorAction {
  return { type: LOAD_REVIEWS_ERROR, payload };
}

export function switchPage(payload: LoadReviewsActionPayload): SwitchPageAction {
  return { type: SWITCH_PAGE, payload };
}
